export default __webpack_public_path__ + "static/media/task.7db635e7.svg";